/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateProductTypeDto
 */
export interface CreateUpdateProductTypeDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateProductTypeDto
     */
    sysnumber: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProductTypeDto
     */
    nkitw: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProductTypeDto
     */
    signId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProductTypeDto
     */
    constructionProduct: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProductTypeDto
     */
    approved: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProductTypeDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProductTypeDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProductTypeDto
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProductTypeDto
     */
    displayDesc: boolean;
}

export function CreateUpdateProductTypeDtoFromJSON(json: any): CreateUpdateProductTypeDto {
    return CreateUpdateProductTypeDtoFromJSONTyped(json, false);
}

export function CreateUpdateProductTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateProductTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sysnumber': json['sysnumber'],
        'nkitw': json['nkitw'],
        'signId': json['signId'],
        'constructionProduct': json['constructionProduct'],
        'approved': json['approved'],
        'organizationId': json['organizationId'],
        'description': json['description'],
        'groupId': json['groupId'],
        'displayDesc': json['displayDesc'],
    };
}

export function CreateUpdateProductTypeDtoToJSON(value?: CreateUpdateProductTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sysnumber': value.sysnumber,
        'nkitw': value.nkitw,
        'signId': value.signId,
        'constructionProduct': value.constructionProduct,
        'approved': value.approved,
        'organizationId': value.organizationId,
        'description': value.description,
        'groupId': value.groupId,
        'displayDesc': value.displayDesc,
    };
}


